import { NOTIFICATION } from '../types';

const initialState = {
  message: null,
  variant: '',
};

const notification = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION:
      return { ...action.payload };

    default:
      return state;
  }
};

export { notification };
